module.exports = __webpack_public_path__ + "img/chevron_down.7c3d309c.svg";